module.exports = __webpack_public_path__ + "static/media/textediter_title.a632605a.svg";